<template>
  <div class="Rating-gray">
<!--    <img src="@/assets/img/iv_Stars@2x.png" alt="" class="i_logo">-->
    <div class="inline" v-for="(item,index) in itemClasses" :key="index">
      <img  class="fa" :class="item" v-if="item == 'fa-star'"  src="@/assets/img/iv_Stars@2x.png">
      <img  class="fa" :class="item" v-else-if="item == 'fa-star-half-empty'"  src="@/assets/img/iv_halfstar@2x.png">
      <img  class="fa" :class="item" v-else-if="item == 'fa-star-0'"  src="@/assets/img/iv_notselected@2x.png">
    </div>
    <div class="inline">
      <span class="score">{{rating}}</span><span class="minute">分</span>
    </div>
  </div>
</template>

<script>
const LENGTH = 5;

const CLS_ON = "fa-star";
const CLS_HALF = "fa-star-half-empty";
const CLS_OF = "fa-star-0";

export default {
  name:"Rating",
  props:{
    rating:Number
  },
  computed:{
    itemClasses(){
      let result = [];
      // 如 4.8 对分数进行处理, 向下取0.5的倍数
      let score = Math.floor(this.rating*2)/2;
      // 用来判断哪种星星的标准
      let integer = Math.floor(score);
      let hasDecimal = score % 1 !== 0;
      for (let i = 0; i < integer; i++) {
        result.push(CLS_ON);
      };
      if(hasDecimal) {
        result.push(CLS_HALF);
      };
      while(result.length < LENGTH) {
        result.push(CLS_OF);
      };
      return result;
    }
  }
}
</script>

<style scoped>
  .inline{
    display: inline-block;
  }
  .fa{
    width: 21px;
    height: 19px;
    float: left;
    margin-right: 6px;
  }
  .Rating-gray {
    margin-right: 1.066667vw;
    color: #ffbe00;
    display: inline-block;
  }
  .score{
    margin-left: 16px;
    color: #FFAF46;
    font-size: 30px!important;
    /*float: left;*/
  }
  .minute{
    color: #FFAF46;
    font-size: 12px!important;
  }
</style>
